import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/buildhome/repo/src/layouts/blogPost.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Link = makeShortcode("Link");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><strong parentName="p">{`Uniswap V1`}</strong>{` was the proof-of-concept for a new type of decentralized marketplace.`}</p>
    <p>{`As a venue for pooled, automated liquidity provision on Ethereum, the Uniswap protocol (Uniswap) functions without upkeep, providing an unstoppable platform for ERC20 token conversion. `}<strong parentName="p">{`Uniswap V1 will continue to work for as long as Ethereum exists`}</strong>{`, and so far, it has worked very nicely for a wide variety of use cases.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {}
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1200px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/928c430d3a3cd382fb699c009c663723/f349c/v1_liquidity.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "66.66666666666666%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsSAAALEgHS3X78AAABUUlEQVQoz52S3UvCUBiH959HNwpFVBKzdB+VH7PSBVkDF51mocJkQvMj51IsqhuDXFtrH+6sY0sKu2n+rs65eHh+vO+LTSYTCKG/QCDELMtyXXcB1vE8zLZtJA9LutBr9TtTeAGzaZqgIoSuHQxobBqiyIerDb9oz/eFWvmGC2OGM62ktPeYTK8OMEQG2/pPEKk+3mdP2GsmxRVTmOM4f2sHkt8MyodjN4f9QlXgT9mdaGZjfWsKz9Weuxn00VxHNXRw2zqqgIsSx8ayS2t0iuW/a/szFXp4EGqW9aBpvZdR++m5qnbPmtKxLJX5okji6chKdLuQrr2CrvlTG85mKapKpiwwABSYQy5OAZy4JOgqRSQjq8uRxGa+jkj6alSSxxiyITVal6Ebb7p+NxikcwfU7j5JkBSeoPEkjRN0nEjG4vnzBlAtQTFBR+PlcWP4/gkch9IQSAhi1QAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="a" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Uniswap V1 Liquidity Growth",
              "title": "Uniswap V1 Liquidity Growth",
              "src": "/static/928c430d3a3cd382fb699c009c663723/c1b63/v1_liquidity.png",
              "srcSet": ["/static/928c430d3a3cd382fb699c009c663723/5a46d/v1_liquidity.png 300w", "/static/928c430d3a3cd382fb699c009c663723/0a47e/v1_liquidity.png 600w", "/static/928c430d3a3cd382fb699c009c663723/c1b63/v1_liquidity.png 1200w", "/static/928c430d3a3cd382fb699c009c663723/d61c2/v1_liquidity.png 1800w", "/static/928c430d3a3cd382fb699c009c663723/f349c/v1_liquidity.png 2002w"],
              "sizes": "(max-width: 1200px) 100vw, 1200px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Uniswap V1 Liquidity Growth`}</figcaption>{`
  `}</figure></p>
    <p>{`However, pooled automated liquidity remains nascent technology, and `}<strong parentName="p">{`we have only just begun to realize its potential`}</strong>{`. For this reason, last year `}<a parentName="p" {...{
        "href": "https://finance.yahoo.com/news/paradigm-backs-decentralized-exchange-protocol-184824051.html"
      }}>{`we raised a seed round`}</a>{` and formed a dedicated team to research and develop Uniswap alongside the broader Ethereum community.`}</p>
    <p><strong parentName="p">{`Uniswap V2`}</strong>{` is our second iteration of Uniswap and includes many new features and improvements. This article will serve as a high-level overview of these changes including:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#erc20--erc20-pairs"
        }}>{`ERC20 / ERC20 Pairs`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#price-oracles"
        }}>{`Price Oracles`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#flash-swaps"
        }}>{`Flash Swaps`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#corehelper-architecture"
        }}>{`Core/Helper Architecture`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#technical-improvements"
        }}>{`Technical Improvements`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#path-to-sustainability"
        }}>{`Path to Sustainability`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#testnet-and-launch-details"
        }}>{`Testnet and Launch Details`}</a></li>
    </ul>
    <p>{`For full details check out the:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/Uniswap/uniswap-v2-core/"
        }}>{`Core smart contracts`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/Uniswap/uniswap-v2-periphery"
        }}>{`Periphery smart contracts`}</a></li>
      <li parentName="ul"><a href='/whitepaper.pdf' target='_blank' rel='noopener noreferrer'>Uniswap V2 Technical Whitepaper</a></li>
      <li parentName="ul"><Link to='/docs/v2/' mdxType="Link">Uniswap V2 Documentation</Link> (in progress!)</li>
    </ul>
    <h2 {...{
      "id": "erc20--erc20-pairs",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#erc20--erc20-pairs",
        "aria-label": "erc20  erc20 pairs permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`ERC20 / ERC20 Pairs`}</h2>
    <p>{`In Uniswap V2, `}<strong parentName="p">{`any ERC20 token can be pooled directly with any other ERC20 token`}</strong>{`. Wrapped Ether (WETH) is used instead of native ETH in the core contracts, although end users can still use ETH through helper contracts.`}</p>
    <p>{`In Uniswap V1, all liquidity pools are between ETH and a single ERC20 token. Having a constant numeraire provides a nice UX advantage — users can swap any ERC20 for any other ERC20 by routing through ETH. Since ETH is the most liquid Ethereum-based asset, and does not introduce any new platform risk, it was the best choice for Uniswap V1.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/4289820d83c2d5c006bed121ec281580/5c263/v1_DAI_USDC_swap.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "80%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAACXBIWXMAACE4AAAhOAFFljFgAAABmklEQVQ4y5VUa3ObMBDM//9d/eL4k12csV2mgZnErh8QsEEvpNuehENsIjepZg7BoVv2diUeiMiiH3SZ4ZwD5z9FWETDsuvxnnQPfLFkCVJIapoGnelwb9wB+wxYHksskgUtl0vsdjvkeR5iv9+H56qqYK0dQCPMbwF9UZIktFqtkKYpZrMZ5vM5sizDdDrFZDKBlPJ7gDEN/7dl+njRMwx3nHTDVy/GWAlnFchZvJf41utTg6o+89zC9JqPARnECuYqEMIxiC5gi0fYww848cI5zSsFm9bid/aKn8kaWb6BUmbcsgd0nFKBOPMcaeSGnK/zzN+qE47FW2Da9WbdMvSCl2VJg+hf7A0/WiGv9+YtYM16bLeHARBRJ2/n7Z8jtDZxQCEVTmdxAYy7Oc751u+6zAcFrSa6LlSGtWosqtZC6I9i7+rp3AYd/Wy6LmYKoDsioSkUK0M41B3WG4VfW4WXwoSc5CjrFsvVM5KnFOs0D1pe8Yhv7H+17HXzDhdlxVFDGxPbh70O47/KN/808ZPy1dG796HxWf4LSsnoysPuHRAAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "v1 DAI USDC swap",
            "title": "v1 DAI USDC swap",
            "src": "/static/4289820d83c2d5c006bed121ec281580/c1b63/v1_DAI_USDC_swap.png",
            "srcSet": ["/static/4289820d83c2d5c006bed121ec281580/5a46d/v1_DAI_USDC_swap.png 300w", "/static/4289820d83c2d5c006bed121ec281580/0a47e/v1_DAI_USDC_swap.png 600w", "/static/4289820d83c2d5c006bed121ec281580/c1b63/v1_DAI_USDC_swap.png 1200w", "/static/4289820d83c2d5c006bed121ec281580/5c263/v1_DAI_USDC_swap.png 1636w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`However, the introduction of ERC20 token/ERC20 token pools in Uniswap V2 can be `}<strong parentName="p">{`useful for liquidity providers, who can maintain more diverse ERC20 token denominated positions`}</strong>{`, without mandatory exposure to ETH. One example would be a DAI/USDC pair, which should theoretically have little volatility for liquidity providers, but is useful for trading.`}</p>
    <p>{`Having direct ERC20/ERC20 pairs can also improve prices because routing through ETH for a swap between two other assets (say, DAI/USDC) involves paying fees and slippage on two separate pairs instead of one.`}</p>
    <p>{`If two ERC20 tokens are not paired directly, and do not have a common pair between them, they can still be swapped as long as a path between them exists. Router contracts can be used to optimize between direct and multi-step swaps.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/c89a7f55518c0d6ca47d4b4813722c01/ec9b3/v2_swaps.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "126.33333333333334%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAZCAYAAAAxFw7TAAAACXBIWXMAACE4AAAhOAFFljFgAAACrklEQVQ4y41VCZLiMAyc//9va2vOBQIJ5Can46tXUi5gmIFUqTC205a7W8oLAEcBa63Hg8f7h1vw4px3n++fCILAR1GEJEmQZRmKopBxmqYyds49BUqAzjFQWZaeQBHHMYNjv9/jeDzicDggDMMF6CEgbXDTxqeu/FsIIHHnpmwowx36vv81E//gQMlwGAYRpVeKABWUGmSx7TrkeYHyXMEYIzx6FcNZDUfrw6BprUZVtwvHkmGWFTDW+KpucIozxEkO6wz9Znj72ODjc4uOwLXRCJMCLR1qrcGZDtrsQgSHEye0cqi1vnsbzpJPttPp/AyG59c95JJrDmcf+vEZr3Wx4ZK7y6l7FC8c3vJ9CTqGnYLmiQoe04D2WeGRgzNdfBjsduw1z37bjWMSRk3w/LKm9ym8EVG87WiOwFSHzTaUMOaGQ1aZleQxZ8jBJ7dNJarPGfBV/cUVec/sCgEkZJeSyoMefJqVCKMEVVWLZd7eN/jz9x2vb19ijVtz88NgatArh3xl9h75ypODRH5R1o78dMrIC7Mtbs2gtZF9C+Cs8k9FYGhVWw5PXvWIz+S/1oJ7U90obHeReJEzXTicruAf1SqHdWPw6ZqE4GI4V80qCmd4C7iQ/0T/e8qHa0YY7SI2cVLnRVlRGSrJiPnj7Liel9JjUcJQep7nrlOdz9fHOir8IRM/FmWJr38HZPlZOOu6nvrmCVvy4SyMZDh2GOWbpkXbdlL4NY2LIkdD/3/9DNhJtfnK0m3ykq/j05Tbfk42UQj2EXnwA7sgvKLhihYeNKRu2V9zeK/b8KLSl53mB4EkQ/fdh7e2mZWuOifeYx9meYU99b6EemKqK2S6xjFKZa7r1fdvygq2/nINm+kLW5LC3HwzKtHeDhJcridqxP1s7HuVcu8L94wnec9/dcSphCHJUW0AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "v2 swaps",
            "title": "v2 swaps",
            "src": "/static/c89a7f55518c0d6ca47d4b4813722c01/c1b63/v2_swaps.png",
            "srcSet": ["/static/c89a7f55518c0d6ca47d4b4813722c01/5a46d/v2_swaps.png 300w", "/static/c89a7f55518c0d6ca47d4b4813722c01/0a47e/v2_swaps.png 600w", "/static/c89a7f55518c0d6ca47d4b4813722c01/c1b63/v2_swaps.png 1200w", "/static/c89a7f55518c0d6ca47d4b4813722c01/d61c2/v2_swaps.png 1800w", "/static/c89a7f55518c0d6ca47d4b4813722c01/97a96/v2_swaps.png 2400w", "/static/c89a7f55518c0d6ca47d4b4813722c01/ec9b3/v2_swaps.png 2539w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`We still anticipate ETH pairs being very popular, but expect to see growth in other types of pairs over time.`}</p>
    <h2 {...{
      "id": "price-oracles",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#price-oracles",
        "aria-label": "price oracles permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Price Oracles`}</h2>
    <p><strong parentName="p">{`Uniswap V2 implements new functionality that enables highly decentralized and manipulation-resistant on-chain price feeds.`}</strong>{` This is achieved by measuring prices when they are expensive to manipulate, and cleverly accumulating historical data. This allows external smart contracts to create gas-efficient, time-weighted averages of Uniswap prices across `}<strong parentName="p">{`any`}</strong>{` time interval.`}</p>
    <p><strong parentName="p">{`On-chain price feeds are a critical component for many decentralized financial applications`}</strong>{` including those similar to derivatives, lending, margin trading, prediction markets and more. Despite `}<a parentName="p" {...{
        "href": "https://arxiv.org/abs/1911.03380"
      }}>{`closely tracking the real-world price`}</a>{` most of the time, Uniswap V1 cannot be used safely as a price oracle because the price can move significantly in a short period of time.`}</p>
    <p>{`Uniswap V2 includes a number of improvements for price feeds built on top of it. First, every pair measures (but does not store) the market price at the beginning of each block, before any trades take place. This price is expensive to manipulate because it was set by the last transaction in a previous block.`}</p>
    <p><strong parentName="p">{`To set the measured price to one that is out of sync with the global market price, an attacker has to make a bad trade at the end of a previous block`}</strong>{` , typically with no guarantee that they will be able to arbitrage it back in the next block. Attackers will lose money to arbitrageurs, unless they can “selfishly” mine two blocks in a row. This type of attack presents a number of challenges and `}<a parentName="p" {...{
        "href": "https://arxiv.org/abs/1912.01798"
      }}>{`has not been observed to date`}</a>{`.`}</p>
    <p>{`This alone is not enough. If significant value settles based on the price resulting from this mechanism, then the profit of an attack likely can outweigh the loss.`}</p>
    <p>{`Instead, Uniswap V2 adds this end-of-block price to a single cumulative-price variable in the core contract weighted by the amount of time this price existed. `}<strong parentName="p">{`This variable represents a sum of the Uniswap price for every second in the entire history of the contract.`}</strong></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/305e79bfff0602175a5d2948fc4a820d/35c87/v2_onchain_price_data.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "85%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAYAAADdRIy+AAAACXBIWXMAACE4AAAhOAFFljFgAAACDUlEQVQ4y41Ui3KjMAzk/z/v2mRu2iOkTY9nAPMwxmB7TzIJk6T0Ws9oPH5otStZDgBYOMDRwA/H/64G1lh7CA8Iw9BVVYWyLJFlGc7n82pFUUAI4ffbtl1Bt4ADSyPPc6Rp6tghSRJ8nE4ehI32yRIfKI5jcNBHwFvgwEu+KLmXdT//VP4F0EdzRBZq1CRLoiHrOgk9TZjmGXwmRONTwLJ5vclwwbF8wdfFkA2pgHzNMcRioWgWZ6VGDMOAkYJqrbcB6ZJ9et7j19PORcd3r9v0I6a0xdwouJOAJXOT+VLyrXmGxhjMxriZpI0kUaUNBmaYEBCxx+wVoKkEyo8Uqpce7Cr7tkABgVnOTS2E49nMBmlf40XEfuaL1vFTdZB1B5lUUI3ENM2bbAPKhX15/YPo+Oby4kzpWtgwU2KNWJbetLkHKOhuGEZgn3NZoarFAvj4bKg2KHqBiBgWxND6QlkfqCWnJE/Ryt5X3xdIc4HoJdB6zSEzMpxDYsSHuZCI8hZZLS+SKZZdJCeCOqer0athu/XGcbS7/W887/bu+HbyAGWjcUgGFEIjrmf8rWbo2T0m7FOFV4b+8U6T40RzpfNaIcoUskqRVEe5ZLO0LnA4ZcirnnJ8Bfmm9Ri07wd0ZFKqtffYqVcSoqMzqdEP+utOuWyuPxi9JGJq/Pzdd/VFL1/PPn9Jtyy27BH0H7upMQHj8oo1AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "v2 onchain price data",
            "title": "v2 onchain price data",
            "src": "/static/305e79bfff0602175a5d2948fc4a820d/c1b63/v2_onchain_price_data.png",
            "srcSet": ["/static/305e79bfff0602175a5d2948fc4a820d/5a46d/v2_onchain_price_data.png 300w", "/static/305e79bfff0602175a5d2948fc4a820d/0a47e/v2_onchain_price_data.png 600w", "/static/305e79bfff0602175a5d2948fc4a820d/c1b63/v2_onchain_price_data.png 1200w", "/static/305e79bfff0602175a5d2948fc4a820d/d61c2/v2_onchain_price_data.png 1800w", "/static/305e79bfff0602175a5d2948fc4a820d/97a96/v2_onchain_price_data.png 2400w", "/static/305e79bfff0602175a5d2948fc4a820d/35c87/v2_onchain_price_data.png 2569w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`This variable can be used by external contracts to track accurate time-weighted average prices (TWAPs) across any time interval.`}</p>
    <p>{`This is done by reading the cumulative price from an ERC20 token pair at the beginning and at the end of the interval. The difference in this cumulative price can then be divided by the length of the interval to create a TWAP for that period.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/f134d0d4763a11354a400c3c944aecad/c6f3b/v2_twap.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "52.66666666666667%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAACE4AAAhOAFFljFgAAABnElEQVQoz41Ti46bMBDM//9gA+FyFwgQHsfD+AXGnq43VZpUF6mWxjaL2Z0ZLwcExHGf/3OE8P74ITkmSNM0nM9nXC4XlGWJoigYdV3zGmN5nuN6vWIYhkfSn3AwxkBrHcZxhBACSilM0wQpJe9jLGJZFl6ttS9Mn8EM46SUDt6/yojP27a9xJxzWNf1rWxmOI4C0yzCIjW0stjoI6k0xmmheGQlOdE4CcYiFaReqZhjJV3XoW1bVsMMi6JCmn2E8bOB+ehJ0sqJun5E/z3he5iJ1YaqapGeMnyVPbLacNKcPE+SBFmWsb/eexxidaoW9m2Hd/5Bfd89H/B/pDm3M6sY32i//yP5cSnxpXM+WGIxC5K4KJaltOE1spVkx/0c2WEcjN6wSgtLMbtFXwlEiBOWVUNSzuxhXpQ4Jiecsk985RV+HVPeDyRdUIJm0EgrhVsxwSQ3yGaGXgyKsiYv7+10UNpSSyhmGKvcbi2atmfvyqrGIlRUgDkmHC26eYWYNGy3wNQzjIh+UusZe2f414Lw9g/wP7XIE559/A2y/1QNA7UCEgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "v2 twap",
            "title": "v2 twap",
            "src": "/static/f134d0d4763a11354a400c3c944aecad/c1b63/v2_twap.png",
            "srcSet": ["/static/f134d0d4763a11354a400c3c944aecad/5a46d/v2_twap.png 300w", "/static/f134d0d4763a11354a400c3c944aecad/0a47e/v2_twap.png 600w", "/static/f134d0d4763a11354a400c3c944aecad/c1b63/v2_twap.png 1200w", "/static/f134d0d4763a11354a400c3c944aecad/d61c2/v2_twap.png 1800w", "/static/f134d0d4763a11354a400c3c944aecad/97a96/v2_twap.png 2400w", "/static/f134d0d4763a11354a400c3c944aecad/c6f3b/v2_twap.png 2950w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`TWAPs can be used directly or as the basis for moving averages (EMAs and SMAs) as needed.`}</p>
    <p>{`A few notes:`}</p>
    <ul>
      <li parentName="ul">{`For a 10-minute TWAP, sample once every 10 minutes. For a 1-week TWAP, sample once every week.`}</li>
      <li parentName="ul">{`For a simple TWAP, the cost of manipulation increases (approx. linear) with liquidity on Uniswap, as well as (approx. linear) with the length of time over which you average.`}</li>
      <li parentName="ul">{`Cost of an attack is relatively simple to estimate. Moving the price 5% on a 1-hour TWAP is approximately equal to the amount lost to arbitrage and fees for moving the price 5% every block for 1 hour.`}</li>
    </ul>
    <p>{`There are some nuances that are good to be aware of when using Uniswap V2 as an oracle, especially where manipulation resistance is concerned. The `}<a href='/whitepaper.pdf' target='_blank' rel='noopener noreferrer'>{`whitepaper`}</a>{` elaborates on some of them. Additional oracle-focused developer guides and documentation will be released soon.`}</p>
    <p>{`In the meantime, check out our `}<a parentName="p" {...{
        "href": "https://github.com/Uniswap/uniswap-v2-periphery/blob/master/contracts/examples/ExampleOracleSimple.sol"
      }}>{`example implementation`}</a>{` of a 24 hr TWAP Oracle built on Uniswap V2!`}</p>
    <h2 {...{
      "id": "flash-swaps",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#flash-swaps",
        "aria-label": "flash swaps permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Flash Swaps`}</h2>
    <p><strong parentName="p">{`Uniswap V2 flash swaps`}</strong>{` allow you to withdraw as much as you want of any ERC20 token on Uniswap at no upfront cost and do anything you want with them (execute arbitrary code), provided that by the end of the transaction execution, you either:`}</p>
    <ul>
      <li parentName="ul">{`pay for all ERC20 tokens withdrawn`}</li>
      <li parentName="ul">{`pay for a percentage of ERC20 tokens and return the rest`}</li>
      <li parentName="ul">{`return all ERC20 tokens withdrawn`}</li>
    </ul>
    <p>{`Liquidity provider fees are enforced by subtracting 0.3% from all input amounts, even if the input ERC20 tokens are being returned as part of a flash swap.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/3d2e7aa81f9c82214f1171dae5d411bc/d6bb7/v2_flash_swaps.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "78.99999999999999%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAACXBIWXMAACE4AAAhOAFFljFgAAABkUlEQVQ4y61U7W6DMAzk/Z+uUn9Nk9quDRQIEAgJ33CzI1FByzY2zZKxBY5zPtt4+EKmacJfxONzKlW4iRu01uj7HsMwPJL+NrHHB06nE47HI87nMw6HA6Ioekk4+1u6rMjjR1mWhK50CPM8hzEG4zj+mGgzITucJEkk0jSFlNLpNI27y1zS4hAaW6PretR1S8gmlKZCEEpEMqN3FmMdkq0RxSnu9D6MEuez7YjzF4QhBRljIfw7HWygVIHLhw//LtG1LdBrd2GaFZBJhoSayCoThX7RwEfCWRjdZkk7S2brEsZxjCAIXHeFEGiovK2k343QqsvMj7WV6zRbLruqSMn2w4SxLRyPXEDXdcSxpcmwxH3lfI59IGQnJoK1NsRLjqZpqeMKb+8X4jGALg0sjVGpC9iqRpblEEFMixAiII6FH7vmrAabUc3bwcKd41sZKUumNM4X320RxwsR4HoVdOHVaVXVa4RLHrZ4GobRlTrHMDV5XkDR/LK2i2/e88RvbceeH8aqKVvI9u7xc5yHf5ZPL0TmikUEYsIAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "v2 flash swaps",
            "title": "v2 flash swaps",
            "src": "/static/3d2e7aa81f9c82214f1171dae5d411bc/c1b63/v2_flash_swaps.png",
            "srcSet": ["/static/3d2e7aa81f9c82214f1171dae5d411bc/5a46d/v2_flash_swaps.png 300w", "/static/3d2e7aa81f9c82214f1171dae5d411bc/0a47e/v2_flash_swaps.png 600w", "/static/3d2e7aa81f9c82214f1171dae5d411bc/c1b63/v2_flash_swaps.png 1200w", "/static/3d2e7aa81f9c82214f1171dae5d411bc/d61c2/v2_flash_swaps.png 1800w", "/static/3d2e7aa81f9c82214f1171dae5d411bc/d6bb7/v2_flash_swaps.png 2157w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`It is often the case that a series of transactions on Ethereum has a high upfront cost but ultimately a low net cost or is even net profitable by the end of the series. `}<strong parentName="p">{`Flash swaps`}</strong>{` are incredibly useful because they `}<strong parentName="p">{`remove upfront capital requirements and unnecessary constraints on order-of-operations`}</strong>{` for multi-step transactions that use Uniswap.`}</p>
    <p>{`One example is `}<strong parentName="p">{`arbitrage with no upfront capital`}</strong>{`. Imagine a scenario where you can sell 200 DAI for 1 ETH on Uniswap and then sell that 1 ETH on Oasis for 220 DAI at a 20 DAI profit. But, unfortunately, you don’t have any DAI in your wallet.`}</p>
    <p><img parentName="p" {...{
        "src": "/04736148d9854c4feea27773fe862d24/no_capital.gif",
        "alt": null
      }}></img></p>
    <p>{`With flash swaps you could synchronously withdraw 1 ETH from Uniswap, sell it on Oasis for 220 DAI and then pay for the ETH on Uniswap with 200 of the DAI you just purchased.`}</p>
    <p>{`Another example use case is `}<strong parentName="p">{`improving the efficiency of margin trading protocols`}</strong>{` that borrow from lending protocols and use Uniswap for ERC20 token conversion. This is currently done with the following process:`}</p>
    <ol>
      <li parentName="ol">{`add user ETH to Maker,`}</li>
      <li parentName="ol">{`borrow DAI from Maker`}</li>
      <li parentName="ol">{`swap DAI for ETH on Uniswap`}</li>
      <li parentName="ol">{`repeat steps 1–3 `}<strong parentName="li">{`multiple times`}</strong>{` until you reached desired leverage`}</li>
    </ol>
    <p>{`With flash swaps this process is simplified to:`}</p>
    <ol>
      <li parentName="ol">{`withdraw all ETH you want from Uniswap`}</li>
      <li parentName="ol">{`add user and Uniswap ETH to Maker`}</li>
      <li parentName="ol">{`borrow all DAI you need from Maker`}</li>
      <li parentName="ol">{`return DAI to the Uniswap protocol`}</li>
    </ol>
    <p>{`If the Uniswap pool does not receive enough DAI to cover the ETH withdrawn, then the entire transaction will revert; thus, all ERC20 tokens are returned or paid for at the end of the transaction.`}</p>
    <h2 {...{
      "id": "corehelper-architecture",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#corehelper-architecture",
        "aria-label": "corehelper architecture permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Core/Helper Architecture`}</h2>
    <p><a parentName="p" {...{
        "href": "https://github.com/Uniswap/uniswap-v2-core"
      }}>{`Uniswap V2 Core`}</a>{` are the essential Uniswap V2 smart contracts, consisting of:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/Uniswap/uniswap-v2-core/blob/master/contracts/UniswapV2Pair.sol"
        }}>{`UniswapV2Pair.sol`}</a>{`, which implements core swapping and liquidity provision functionality`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/Uniswap/uniswap-v2-core/blob/master/contracts/UniswapV2Factory.sol"
        }}>{`UniswapV2Factory.sol`}</a>{`, which deploys `}<a parentName="li" {...{
          "href": "https://github.com/Uniswap/uniswap-v2-core/blob/master/contracts/UniswapV2Pair.sol"
        }}>{`UniswapV2Pair.sol`}</a>{` contracts for any ERC20 token/ERC20 token pair`}</li>
    </ul>
    <p><strong parentName="p">{`Core is minimalist in design, removing all logic that is not strictly necessary to secure liquidity stored in its pools.`}</strong>{` Logic related to trader security or ease-of-use must be implemented in external helper contracts. Since external helpers can be improved and replaced without needing to migrate liquidity, `}<strong parentName="p">{`this improves on the flexibility and modularity of Uniswap.`}</strong></p>
    <p><a parentName="p" {...{
        "href": "https://github.com/Uniswap/uniswap-v2-periphery"
      }}>{`Uniswap V2 Periphery`}</a>{` (periphery) is an initial set of helpers, including:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/Uniswap/uniswap-v2-periphery/blob/master/contracts/UniswapV2Router01.sol"
        }}>{`A router contract`}</a>{` that performs the safety checks needed for safely swapping, adding, and removing liquidity.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/Uniswap/uniswap-v2-periphery/blob/master/contracts/UniswapV2Migrator.sol"
        }}>{`A migrator contract`}</a>{` that can remove liquidity from Uniswap V1 and deposit it into Uniswap V2 in a single transaction.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/Uniswap/uniswap-v2-periphery/blob/master/contracts/libraries/UniswapV2Library.sol"
        }}>{`A library contract`}</a>{` that can be used in the creation of other helper contracts.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/Uniswap/uniswap-v2-periphery/blob/master/contracts/examples/ExampleOracleSimple.sol"
        }}>{`An example oracle contract`}</a>{` that creates a simple TWAP from Uniswap V2 cumulative prices.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/Uniswap/uniswap-v2-periphery/blob/master/contracts/examples/ExampleFlashSwap.sol"
        }}>{`An example flash swap contract`}</a>{` that withdraws ERC20 tokens, executes arbitrary code, and then pays for them.`}</li>
    </ul>
    <p><em parentName="p">{`Periphery contracts described as “Example” are for illustrative purposes only and should not be used in actual transactions.`}</em></p>
    <p>{`While this is a huge improvement, there are some new smart contract patterns introduced which developers building on top of Uniswap should be aware of.`}</p>
    <ul>
      <li parentName="ul">{`Core uses WETH instead of ETH. Routers can convert between ETH and WETH allowing users to use ETH directly`}</li>
      <li parentName="ul">{`Core stores ERC20 token balances internally instead of relying on the balances stored in the ERC20 token contract`}</li>
      <li parentName="ul">{`Core no longer calls `}<strong parentName="li">{`transferFrom`}</strong>{` on `}<strong parentName="li">{`msg.sender`}</strong>{`. Instead ERC20 tokens should be sent to core directly by a router before calling the `}<strong parentName="li">{`swap`}</strong>{` , `}<strong parentName="li">{`mint`}</strong>{` or `}<strong parentName="li">{`burn`}</strong>{` functions.`}</li>
      <li parentName="ul">{`Core will determine the number of ERC20 tokens sent to it based on the difference between its current and stored balances.`}</li>
      <li parentName="ul">{`Core no longer returns the maximum number of ERC20 tokens for a given input amount. Instead, a router must specify the number of ERC20 tokens it wants. Core will send this number as long as the invariant is preserved after taking 0.3% off any input amount.`}</li>
      <li parentName="ul">{`Routers should handle logic around slippage safety checks and multihop trades.`}</li>
    </ul>
    <p>{`For additional details please read the `}<Link to='/docs/v2/protocol-overview/smart-contracts/' mdxType="Link">{`architecture section`}</Link>{` of the in-progress Uniswap V2 docs or the core and periphery smart contracts themselves.`}</p>
    <h2 {...{
      "id": "technical-improvements",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#technical-improvements",
        "aria-label": "technical improvements permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Technical Improvements`}</h2>
    <p>{`Uniswap V2 contains many other significant changes and improvements including the following:`}</p>
    <ul>
      <li parentName="ul">{`Smart contracts are written in Solidity instead of Vyper`}</li>
      <li parentName="ul">{`Use CREATE2 to make the pool address deterministic based on the ERC20 token pair`}</li>
      <li parentName="ul">{`Uniswap V2 properly handles `}<a parentName="li" {...{
          "href": "https://medium.com/coinmonks/missing-return-value-bug-at-least-130-tokens-affected-d67bf08521ca"
        }}>{`“missing return” ERC20 tokens`}</a>{` that do not work on Uniswap V1, such as USDT and OMG`}</li>
      <li parentName="ul">{`Built in metaTransaction “approve” function for liquidity tokens`}</li>
      <li parentName="ul">{`Increase re-entrancy protection using mutex (adds support for ERC777 and other non-standard ERC20 tokens)`}</li>
      <li parentName="ul">{`Fix bug from Uniswap V1 that uses all remaining gas on failing transactions`}</li>
      <li parentName="ul">{`More descriptive error messages. The above bug caused failing transactions to only return the error “Bad Jump Destination”`}</li>
    </ul>
    <h2 {...{
      "id": "path-to-sustainability",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#path-to-sustainability",
        "aria-label": "path to sustainability permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Path to Sustainability`}</h2>
    <p>{`Decentralization is in many ways about increasing participation and removing central points of failure. Uniswap V1 is already highly decentralized, trustless, and censorship resistant. But for it to achieve its full potential as infrastructure in a fair and open financial system — `}<strong parentName="p">{`it must continue to grow and improve`}</strong>{`.`}</p>
    <p>{`To open a path to self-sustainability, the code for Uniswap V2 includes a small protocol charge mechanism. At launch, the protocol charge will default to 0, and the liquidity provider fee will be 0.30%. If the protocol charge is switched on, it will become 0.05% and the liquidity provider fee will be 0.25%.`}</p>
    <p>{`This feature, including the exact percentage amounts, is hardcoded into the core contracts which remain decentralized and non-upgradable. It can be turned on, and directed by, a decentralized governance process deployed after the Uniswap V2 launch. There is no expectation that it will be turned on in the near future but it opens the possibility for future exploration.`}</p>
    <p><blockquote parentName="p" {...{
        "className": "twitter-tweet",
        "data-dnt": "true"
      }}><p parentName="blockquote" {...{
          "lang": "en",
          "dir": "ltr"
        }}>{`DAO: "an entity that lives on the internet and exists autonomously, but also heavily relies on hiring individuals to perform certain tasks that the automaton itself cannot do."`}<br parentName="p"></br><br parentName="p"></br>{`"Automation at the center, humans at the edges"`}<br parentName="p"></br><br parentName="p"></br>{` —`}<a parentName="p" {...{
            "href": "https://twitter.com/VitalikButerin"
          }}>{`@VitalikButerin`}</a>{` (2014)`}<a parentName="p" {...{
            "href": "https://t.co/63UgPgXrMq"
          }}>{`https://t.co/63UgPgXrMq`}</a></p>{`— Jesse Walden (@jessewldn) `}<a parentName="blockquote" {...{
          "href": "https://twitter.com/jessewldn/status/1135741055045967874"
        }}>{`June 4, 2019`}</a></blockquote></p>
    <p>{`In the Classical Period of crypto (2014), `}<a parentName="p" {...{
        "href": "https://blog.ethereum.org/2014/05/06/daos-dacs-das-and-more-an-incomplete-terminology-guide/"
      }}>{`Vitalik described`}</a>{` decentralized autonomous organizations (DAOs) as “automation at the center, humans at the edges.”`}</p>
    <blockquote>
      <p parentName="blockquote">{`an entity that lives on the internet and exists autonomously, but also heavily relies on hiring individuals to perform certain tasks that the automaton itself cannot do`}</p>
    </blockquote>
    <p>{`This perfectly describes the Uniswap protocol’s path forward. In Uniswap V1 pricing, coordination, listing, and trade execution are fully automated while arbitrage and liquidity provision are incentivized.`}</p>
    <p>{`However, `}<strong parentName="p">{`the best version of Uniswap will be one that autonomously incentivizes contributions to its own growth and development`}</strong>{` as well as to the broader ecosystem in which it exists—one that supports the contributions of the `}<strong parentName="p">{`incredible community`}</strong>{` that has formed and continues to grow.`}</p>
    <p>{`Uniswap is an ideal candidate for exploring decentralized on-chain cash flows. `}<strong parentName="p">{`Without any additional growth`}</strong>{`, it will generate more than $5M in liquidity provider fees this year. If the protocol charge was on, ~$830,000 of this would instead go to a decentralized funding mechanism used to support contributions to Uniswap and its ecosystem.`}</p>
    <p><strong parentName="p">{`This type of support boosts network effects from which Uniswap and its users benefit greatly.`}</strong>{` Incentivized contributions lead to increased protocol functionality and usage. Usage generates fees which attracts liquidity. Increased liquidity further entrenches Uniswap, attracting additional users, contributors, and integrations.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "900px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/a34d660706547aacdf7dc17465dd7847/8e1fc/graph.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAwQA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAZpXnBzZP//EABoQAQEBAAMBAAAAAAAAAAAAAAECAwAEEyL/2gAIAQEAAQUCevqAPpVfWWzze4qlyT//xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAgBAwEBPwGq/8QAFREBAQAAAAAAAAAAAAAAAAAAEEH/2gAIAQIBAT8Bp//EABwQAAMAAgMBAAAAAAAAAAAAAAABEQIhEiJBYf/aAAgBAQAGPwJdrSZNmsnDb+C4oxts8R//xAAaEAEAAgMBAAAAAAAAAAAAAAABABEhMUFh/9oACAEBAAE/IUVdHHUODztRxDOFjwsvW83L0ijPrEZjC1T/2gAMAwEAAgADAAAAEBDv/8QAGBEBAAMBAAAAAAAAAAAAAAAAAQARITH/2gAIAQMBAT8QReEd8n//xAAXEQEBAQEAAAAAAAAAAAAAAAARAQAx/9oACAECAQE/EE41rXf/xAAdEAEAAgICAwAAAAAAAAAAAAABABEhQTFRcZHh/9oACAEBAAE/EAaOUTLXn5Lxk3LXYECWnQWECmF/JW8YLr3KUvJYGK4AhZfN8u5//9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "graph",
            "title": "graph",
            "src": "/static/a34d660706547aacdf7dc17465dd7847/8e1fc/graph.jpg",
            "srcSet": ["/static/a34d660706547aacdf7dc17465dd7847/f93b5/graph.jpg 300w", "/static/a34d660706547aacdf7dc17465dd7847/b4294/graph.jpg 600w", "/static/a34d660706547aacdf7dc17465dd7847/8e1fc/graph.jpg 900w"],
            "sizes": "(max-width: 900px) 100vw, 900px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`For more details, please refer to the technical `}<a href='/whitepaper.pdf' target='_blank' rel='noopener noreferrer'>{`whitepaper`}</a>{` or code.`}</p>
    <h2 {...{
      "id": "testnet-and-launch-details",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#testnet-and-launch-details",
        "aria-label": "testnet and launch details permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Testnet and Launch Details`}</h2>
    <p>{`While the core smart contracts are finished, additional work is still in progress.`}</p>
    <ul>
      <li parentName="ul">{`Uniswap V2 smart contracts are undergoing formal verification and security auditing. Bug bounties will be used to encourage additional community security review.`}</li>
      <li parentName="ul">{`The interface, analytics site, API, and developer SDK are being updated to work with Uniswap V2.`}</li>
      <li parentName="ul">{`Documentation, guides, and examples are still being worked on.`}</li>
      <li parentName="ul">{`When everything else is ready, a simple migration UX will be released to improve the experience of moving from Uniswap V1 to Uniswap V2`}</li>
    </ul>
    <p>{`Pending a successful formal verification, we are optimistic that Uniswap V2 can be deployed in Q2 of this year. However, please keep in mind that this is a target and not an announced release date.`}</p>
    <p>{`In the meantime, developers can begin playing with Uniswap V2 today! The factory and an initial router smart contract have already been deployed to the Ropsten, Rinkeby, Kovan, and Görli testnets.`}</p>
    <p><strong parentName="p"><Link to='/docs/v2/smart-contracts/factory/#address' mdxType="Link">{`Uniswap V2 Factory (Testnet)`}</Link></strong></p>
    <p><strong parentName="p"><Link to='/docs/v2/smart-contracts/router01/#address' mdxType="Link">{`Uniswap V2 Router 01 (Testnet)`}</Link></strong></p>
    <p><strong parentName="p">{`We want to hear from you!`}</strong></p>
    <p>{`We will be releasing additional updates, information, and documentation over the coming months. We look forward to continued feedback and involvement from the fantastic Uniswap community. To get involved and stay up to date:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://discord.gg/FCfyBSbCU5"
        }}>{`Join the Uniswap community discord`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://twitter.com/Uniswap"
        }}>{`Follow Uniswap on Twitter`}</a></li>
      <li parentName="ul">{`Subscribe to the `}<Link to='/blog/' mdxType="Link">{`Uniswap blog`}</Link></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      